import Sortable from 'sortablejs';

window.sortBewaesserungsanlagen = function() {
  const tableBewaesserungsanlagen = document.getElementById('list_bewaesserungsanlagen');

  Array.prototype.forEach.call(tableBewaesserungsanlagen.querySelectorAll('.bewaesserungsanlagen-list'), function(element) {
    Sortable.create(element, {
      handle: '.dragger',
      draggable: '.bewaesserungsanlage-item',
      animation: 150,
      easing: '',
      group: {
        name: 'bewaesserungsanlage-group',
      },
      onEnd: function(evt) {
        var selectedElement = evt.item.getAttribute('data-bewaesserungsanlage-id');  // dragged HTMLElement

        const elementIDs = [];
        Array.prototype.forEach.call(tableBewaesserungsanlagen.querySelectorAll('.bewaesserungsanlage-item'), function(element) {
          const bewaesserungsanlageID = element.getAttribute('data-bewaesserungsanlage-id');
          elementIDs.push(bewaesserungsanlageID);
        });

        fetch(BASE_PATH + 'ajax/helper/additional/ajax.saveSorting', {
          method: 'POST',
          body: JSON.stringify({
            area: 'bewaesserungsanlagen',
            elements: elementIDs,
          }),
        }).then(function(response) {
          if (typeof ListBewaesserungsanlagen !== 'undefined') {
            ListBewaesserungsanlagen.updater();
          }

          return response.text();
        });
      },
    });
  });
};